import { DEFAULT_OUTPUT_SIZE as MaskDefaultSize } from '../EngravingMask'

export const EDITS_PER_REQUEST = 3
export const DEFAULT_OUTPUT_SIZE = MaskDefaultSize

export const STEPS = [
  { step: 1, label: 'Select Image' },
  { step: 2, label: 'Generate Edits' },
  { step: 3, label: 'Masking' },
]

export const TABS = [
  { label: 'Predefined', value: 0 },
  { label: 'Custom Prompt', value: 1 },
]

export const PRINT_TYPES = [
  { label: 'Fingerprint', value: 'fingerprint' },
  { label: 'Nose Print', value: 'pet_nose_print' },
  { label: 'Paw Print', value: 'pet_paw_print' },
  { label: 'Baby Hands', value: 'baby_hands' },
  { label: 'Baby Feet', value: 'baby_feet' },
  { label: 'Handwriting', value: 'handwriting' },
]

export const GEMINI_25_FLASH_MODEL_VALUE = 'gemini-2.5-flash-image'
export const GEMINI_3_PRO_IMAGE_PREVIEW_VALUE = 'gemini-3-pro-image-preview'

export const MODELS = [
  { label: 'Gemini 2.5', value: GEMINI_25_FLASH_MODEL_VALUE },
  { label: 'Gemini 3', value: GEMINI_3_PRO_IMAGE_PREVIEW_VALUE },
]

/** Default Gemini model for predefined extraction by print type (matches API runner). */
export function defaultModelValueForPrintType(printTypeKey) {
  return ['pet_paw_print', 'baby_feet'].includes(printTypeKey)
    ? GEMINI_3_PRO_IMAGE_PREVIEW_VALUE
    : GEMINI_25_FLASH_MODEL_VALUE
}

/** Re-export for backward compatibility; prefer importing from BacksideEngraving. */
export { BACKSIDE_ENGRAVING_LINE_ITEM_IDS } from './BacksideEngraving'
